
































import { Vue, Component } from 'vue-property-decorator'
import { mapGetters, mapActions, mapState } from 'vuex'
import navigate from '../libs/navigate'

@Component({
  computed: {
    ...mapState('Accounts', { newUserEmail: 'newUserEmail' }),
    ...mapGetters('Accounts', ['isNewUser', 'statusMessage'])
  },
  methods: {
    ...mapActions('Accounts', ['confirmCode']),
    navigate
  }
})
export default class ConfirmCode extends Vue {
  confirmCode!: (code: string) => void
  newUserEmail!: string
  statusMessage!: string
  code = ''
  loading= false

  async submitConfirmCode () {
    if (this.code !== '') {
      this.loading = true
      await new Promise(resolve => setTimeout(resolve, 1000))
      await this.confirmCode(this.code)
      this.loading = false
    }
  }
}
